import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

interface LinkStripePayload {
  company_id: string;
  new_stripe_customer_id: string;
  delete_old_stripe_customer: boolean;
}

interface LinkStripeResponse {
  created_subscriptions: string[];
  stripe_customer_id: string;
  old_stripe_customer_deleted: boolean;
  message?: string;
}

async function linkStripeSubscription(
  payload: LinkStripePayload,
  auth: Authentication
): Promise<LinkStripeResponse> {
  try {
    const response = await HttpClient.post(
      '/company/link-stripe',
      payload,
      auth.token
    );
    return response.data;
  } catch (e: any) {
    console.error('linkStripeSubscription error:', e);
    throw new LinkStripeFailure(e.message);
  }
}

export class LinkStripeFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default linkStripeSubscription;
